var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-group no-margin row" },
    [
      _c("div", { staticClass: "col-auto" }, [
        _c("label", { staticClass: "col-form-label" }, [
          _vm._v(_vm._s(_vm.label))
        ])
      ]),
      _vm._l(_vm.ranges, function(range) {
        return _c(
          "section",
          { staticClass: "col-auto", attrs: { value: _vm.selected } },
          [
            _c(
              "div",
              {
                staticClass: "block",
                on: {
                  change: function($event) {
                    return _vm.setCycle()
                  }
                }
              },
              [
                _c(
                  "b-radio",
                  {
                    staticClass: "custom-control-inline",
                    attrs: { name: "name", value: range.value },
                    model: {
                      value: _vm.selected,
                      callback: function($$v) {
                        _vm.selected = $$v
                      },
                      expression: "selected"
                    }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(range.text) +
                        "\n            "
                    )
                  ]
                )
              ],
              1
            )
          ]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }